export default __webpack_public_path__ + "be28cf9b9c882efad4df5e6e87297c81.jpg";